var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5432_33745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4935 0H26.5065C40.8434 0 52.5 11.6632 52.5 26C52.5 40.3368 40.8412 52 26.5065 52C21.2199 52 16.3145 50.4248 12.2065 47.7057L2.21169 50.8993L5.45086 41.2382C2.22582 36.8126 0.491971 31.476 0.500028 26C0.500028 11.6632 12.1589 0 26.4935 0ZM19.0554 14.2913C18.5592 13.1062 18.1822 13.0607 17.4304 13.0303C17.1447 13.0118 16.8586 13.0016 16.5724 13C15.593 13 14.5704 13.286 13.9507 13.9165C13.2032 14.6813 11.3334 16.4667 11.3334 20.1348C11.3334 23.7987 14.0135 27.3433 14.3732 27.8395C14.7502 28.3335 19.5992 35.9645 27.124 39.0737C33.0109 41.5068 34.7572 41.2815 36.0984 40.9955C38.0549 40.5752 40.5075 39.1322 41.125 37.3923C41.7425 35.6482 41.7425 34.1618 41.5627 33.8455C41.3807 33.5313 40.8845 33.3515 40.1327 32.9745C39.3787 32.5997 35.7214 30.797 35.028 30.5565C34.3499 30.303 33.7042 30.3918 33.1929 31.1133C32.4692 32.1187 31.7629 33.1413 31.1887 33.7567C30.738 34.2377 29.9992 34.2983 29.3839 34.0427C28.5562 33.696 26.2379 32.8857 23.3757 30.3463C21.1635 28.379 19.6577 25.9307 19.2222 25.1962C18.7845 24.4443 19.1767 24.0088 19.5234 23.6037C19.8982 23.1378 20.26 22.8085 20.637 22.373C21.014 21.9375 21.222 21.7122 21.4647 21.2008C21.7204 20.7047 21.5405 20.1933 21.3585 19.8185C21.1787 19.4437 19.6729 15.7777 19.0554 14.2935V14.2913Z",
    fill: "#25D366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5432_33745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogoGreen);
export default __webpack_public_path__ + "static/media/whatsapp_logo_green.5a7e14415d115af2a863be675cc32b1d.svg";
export { ForwardRef as ReactComponent };